export default "__VITE_ASSET__CkbcifGM__"